import { useNavigate } from "react-router-dom";
import { useGetUser } from "../auth/useGetUser";
import SpinnerFullPage from "../../ui/SpinnerFullPage";
import InfoModal from "../../ui/InfoModal";
import translation from "../../data/fa-IR.json";

function RequireHasInfo({ children }: { children: React.ReactNode }) {
  const { user, isPending } = useGetUser();
  const navigate = useNavigate();

  if (isPending) return <SpinnerFullPage />;

  if (!user?.has_info) {
    return (
      <InfoModal
        hideTrigger
        open={true}
        // onClose={() => navigate("/profile", { replace: true })}
        onClose={() => {}} 
        title={translation.Dashboard.QuestionsRequiredTitle}
        details={translation.Dashboard.QuestionsRequiredDetails}
        buttonText={translation.Dashboard.GoToQuestions}
        onButtonClick={() => navigate("/questions", { replace: true })}
      />
    );
  }

  return <>{children}</>;
}

export default RequireHasInfo;